import { makeStyles } from "tss-react/mui";
import { EDeviceType, getThemeBreakpointByDeviceType } from "@utils/getThemeBreakpointByDeviceType";

export const useStyle = makeStyles()((theme) => ({
    section: {
        maxWidth: 1249,
        margin: theme.spacing(0, "auto", 8),
        padding: theme.spacing(5, 2),
        [getThemeBreakpointByDeviceType(theme, EDeviceType.MOBILE)]: {
            maxWidth: 600,
        },
    },
    sectionTitle: {
        color: theme.palette.secondary.main,
        marginBottom: theme.spacing(5),
    },
    accordionsWrapper: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(1.5),
    },
    list: {
        color: theme.palette.secondary.main,
        margin: theme.spacing(1, 0, 0),
        // fix padding to match the list item marker
        paddingLeft: theme.spacing(3.5),
        "& li": {
            marginBottom: theme.spacing(1),
        },
        "& li::marker": {
            fontFamily: theme.typography.fontFamily,
            fontSize: theme.typography.normal?.fontSize ?? theme.typography.small?.fontSize ?? "16px",
            fontWeight: theme.typography.fontWeightLight,
        },
    },
    paragraphs: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(1.5),
        color: theme.palette.secondary.main,
    },
}));
